/**
 * Splits a camel case string into separate words with spaces.
 * @param value - The camel case string to split.
 * @returns The string with spaces separating the words.
 */
export const splitCamelCase = (value: string) => value?.replace(/([a-z])([A-Z])/g, '$1 $2');

/**
 * Capitalizes the first letter of each word in a string.
 * @param value - The string to capitalize.
 * @returns The capitalized string.
 */
export const capitalizeWords = (value: string) => value?.split(' ')?.map((word: string) => word[0].toLocaleUpperCase() + word.slice(1))?.join(' ');
